<template>
  <div>
  <van-tabbar v-model="active">
    <van-tabbar-item icon="home-o" @click="toHome">首頁</van-tabbar-item>
    <van-tabbar-item icon="records" @click="toGo">活動紀錄</van-tabbar-item>
    <van-tabbar-item icon="points" @click="toGoScore">健康學分</van-tabbar-item>
    <van-tabbar-item icon="location" @click="toGoact">報到點名</van-tabbar-item>
    <van-tabbar-item v-show="show" icon="user-circle-o" @click="toBind">綁定帳號</van-tabbar-item>
  </van-tabbar>

  </div>
</template>

<script>
//import router from '../../router'
import { mapState } from "vuex";
//import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'


export default {
  name: "Mybottommenu",  
  props: {
    obj: Object, 
    show: Boolean,
  },
  data() {
    return {   
      active: 0,  
      xurl: "",
      imgs: {
        width: 0,
        height: 0
      },
    };
  },
  computed: {
    ...mapState("account", ["user"]),
  },  
  methods: {

    catImg(imgs) {
      return require(`../../assets/${imgs}`);
    },

    covert(type,val){
      if(type=='theme'){        
        let rs= this.mytheme.filter((el)=> { return el.value === val});
        return rs[0].title;
      }
    },
    toHome(){
      this.$emit("savelove","home")
      //this.user.data.user.id
    },  

    toGo(){
      this.$emit("savelove","love")
      //this.user.data.user.id
    },  
    
    toGoScore(){
      this.$emit("savelove","score")
    },
    
    toGoact(){
    this.$emit("savelove","act")
    }, 
    
    toBind(){
      if(this.user.data.user.utoken!==''){
        this.$emit("savelove","bind")
      }
    }, 
    
    onHide(evt) {
          if(evt.trigger === "backdrop"){
              evt.preventDefault();
          }
      },     

  },

};
</script>
<style scoped>
.mobile-grid-bar.dark {
  width: 100vw;
  min-height: 90px;
  background: #181a20;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  box-shadow: 0 -2px 12px rgba(0,0,0,0.22);
  padding: 8px 0 4px 0;
  border-top: 1.5px solid #252834;
}
.grid-btn {
  flex: 1;
  max-width: 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.icon-box {
  width: 54px;
  height: 54px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  margin-bottom: 6px;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(80,80,80,0.19);
}
.mod {
  background: #00e472;
  color: #181a20;
}
.mod:hover { background: #3ef78f; color: #181a20; }
.mcod {
  background: #00e3e0;
  color: #181a20;
}
.mcod:hover { background: #3feef8; color: #181a20; }
.right {
  background: #ffc700;
  color: #181a20;
}
.right:hover {
  background: #ffe266;
  color: #181a20;
}
.rightside {
  background: #8e6fff;
  color: #fff;
}
.rightside:hover {
  background: #bfaaff;
  color: #181a20;
}
.btn-label {
  font-size: 1.04rem;
  color: #fff;
  margin-top: 0;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-align: center;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0,0,0,0.22);
}
@media (max-width: 480px) {
  .icon-box { width: 44px; height: 44px; font-size: 24px; }
  .btn-label { font-size: 0.86rem; }
  .mobile-grid-bar { min-height: 72px; }
}
</style>
<style>
/* 修正放大 150% 時 tabbar 圖示與文字被擠到頂部的問題 */
.van-tabbar {
  height: auto !important;
  min-height: 50px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 4px 0;
}
.van-tabbar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 2px 0;
  box-sizing: border-box;
}
.van-tabbar-item__icon {
  margin-bottom: 2px;
}
.van-tabbar-item__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  font-size: clamp(10px, 2.5vw, 14px);
}
</style>


